import {useQuery} from '@tanstack/react-query';
import {GetObligationPdfParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getObligationPdf} from '../../services/getObligationPdf';

const useGetObligationPdfQuery = (params: GetObligationPdfParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.OBLIGATION_PDF, params],
		queryFn: async ({signal}) => getObligationPdf({...params, signal}),
		enabled: !!params.obrigacao,
	});

export {useGetObligationPdfQuery};
